export default __webpack_public_path__ + "static/media/253.c012fddc.gif";